module.exports = __webpack_public_path__ + "img/keyBuckle_5.4077d72d.jpg";